<script>
export default {
  name: "Animation",
  data: () => ({
    animItems: null,
  }),
  methods: {
    clearAnim() {
      this.animItems = document.querySelectorAll("._anim-items")

      for (let i = 0; i < this.animItems.length; i++) {
        this.animItems[i].classList.remove("_active")
      }
    },

    animOnScroll() {
      this.animItems = document.querySelectorAll("._anim-items")

      for (let i = 0; i < this.animItems.length; i++) {
        let animItem = this.animItems[i]
        let animItemHeight = animItem.offsetHeight
        let animItemOffset = this.offset(animItem).top
        let animStart = 4

        let animItemPoint = window.innerHeight - animItemHeight / animStart
        if (animItemHeight > window.innerHeight) {
          animItemPoint = window.innerHeight - window.innerHeight / animStart
        }

        if ((pageYOffset > animItemOffset - animItemPoint) && pageYOffset < (animItemOffset + animItemHeight)) {
          animItem.classList.add("_active")
        } else {
          // animItem.classList.remove("_active")
        }
      }
    },

    offset(el) {
      let rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop

      return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
  },
  mounted() {
    this.clearAnim()

    setTimeout(() => {
      this.animOnScroll()
      window.addEventListener("scroll", this.animOnScroll)
    }, 300)
  }
}
</script>

<style lang="scss">

._anim-items {
  transition: all 1s ease 0s;
  opacity: 0;
}

</style>